import {
  ADD_NEW_CHAT_TOPIC,
  ADD_NEW_GROUP,
  ADD_NEW_MESSAGE,
  ADD_NEW_MESSAGE_IN_CHAT,
  ADD_NEW_MESSAGE_SLOW,
  ADD_NEW_PERSONAL_GROUP,
  ADD_NEW_SYSTEM_MESSAGE,
  ADD_THINKING_MESSAGE,
  CHANGE_STATUS_CHAT,
  CHANGE_STATUS_CHAT_FAIL,
  CHANGE_STATUS_CHAT_START,
  CHANGE_STATUS_CHAT_SUCCESS,
  CHECK_CHAT_IN_TRACK_FAIL,
  CHECK_CHAT_IN_TRACK_START,
  CHECK_CHAT_IN_TRACK_SUCCESS,
  CHECK_NEW_MESSAGE_FAIL,
  CHECK_NEW_MESSAGE_START,
  CHECK_NEW_MESSAGE_SUCCESS,
  CLEAR_FOUND_GROUPS,
  CLEAR_GROUPS,
  CLEAR_MESSAGES,
  CLEAR_PERSONAL_GROUPS,
  CLEAR_REPLY_MESSAGE,
  CLEAR_SEARCH_USERS,
  CLEAR_SELECTED_BOT,
  CLEAR_SELECTED_CHAT_TOPIC,
  CLEAR_SELECTED_USER,
  CLEAR_USERS,
  CREATE_BREAKOUT_REPORT_FAIL,
  CREATE_BREAKOUT_REPORT_START,
  CREATE_BREAKOUT_REPORT_SUCCESS,
  CREATE_CHAT_GROUP_FAIL,
  CREATE_CHAT_GROUP_START,
  CREATE_CHAT_GROUP_SUCCESS,
  CREATE_CHAT_TOPIC_FAIL,
  CREATE_CHAT_TOPIC_START,
  CREATE_CHAT_TOPIC_SUCCESS,
  CREATE_MINI_GROUP_FAIL,
  CREATE_MINI_GROUP_START,
  CREATE_MINI_GROUP_SUCCESS,
  DELETE_CHAT_GROUP,
  DELETE_CHAT_GROUP_BY_ID_FAIL,
  DELETE_CHAT_GROUP_BY_ID_START,
  DELETE_CHAT_GROUP_BY_ID_SUCCESS,
  DELETE_CHAT_GROUP_USER_FAIL,
  DELETE_CHAT_GROUP_USER_START,
  DELETE_CHAT_GROUP_USER_SUCCESS,
  DELETE_MINI_GROUP_FAIL,
  DELETE_MINI_GROUP_START,
  DELETE_MINI_GROUP_SUCCESS,
  GET_AVAILABLE_TOOLS_FAIL,
  GET_AVAILABLE_TOOLS_START,
  GET_AVAILABLE_TOOLS_SUCCESS,
  GET_BOT_SYSTEM_PROMPT_FAIL,
  GET_BOT_SYSTEM_PROMPT_START,
  GET_BOT_SYSTEM_PROMPT_SUCCESS,
  GET_BOT_TEMPERATURE_FAIL,
  GET_BOT_TEMPERATURE_START,
  GET_BOT_TEMPERATURE_SUCCESS,
  GET_BOT_TOOLS_FAIL,
  GET_BOT_TOOLS_START,
  GET_BOT_TOOLS_SUCCESS,
  GET_BOTS_LIST_FAIL,
  GET_BOTS_LIST_START,
  GET_BOTS_LIST_SUCCESS,
  GET_BREAKOUT_REPORT_FAIL,
  GET_BREAKOUT_REPORT_START,
  GET_BREAKOUT_REPORT_SUCCESS,
  GET_CHAT_BOTS_FAIL,
  GET_CHAT_BOTS_START,
  GET_CHAT_BOTS_SUCCESS,
  GET_CHAT_TOPICS_FAIL,
  GET_CHAT_TOPICS_START,
  GET_CHAT_TOPICS_SUCCESS,
  GET_CHATS_FAIL,
  GET_CHATS_START,
  GET_CHATS_SUCCESS,
  GET_COMPANY_TOKEN_QUOTA_FAIL,
  // Token usage constants
  GET_COMPANY_TOKEN_QUOTA_START,
  GET_COMPANY_TOKEN_QUOTA_SUCCESS,
  GET_COMPANY_TOKEN_USAGE_FAIL,
  GET_COMPANY_TOKEN_USAGE_START,
  GET_COMPANY_TOKEN_USAGE_SUCCESS,
  GET_CURRENT_USER_GROUP_ID_FAIL,
  GET_CURRENT_USER_GROUP_ID_START,
  GET_CURRENT_USER_GROUP_ID_SUCCESS,
  GET_MESSAGES_FAIL,
  GET_MESSAGES_PAGINATED_FAIL,
  GET_MESSAGES_PAGINATED_START,
  GET_MESSAGES_PAGINATED_SUCCESS,
  GET_MESSAGES_START,
  GET_MESSAGES_SUCCESS,
  GET_MINI_GROUP_FAIL,
  GET_MINI_GROUP_START,
  GET_MINI_GROUP_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_IN_CHAT_FAIL,
  GET_USERS_IN_CHAT_START,
  GET_USERS_IN_CHAT_SUCCESS,
  GET_USERS_START,
  GET_USERS_SUCCESS,
  LOAD_MORE_MESSAGES_FAIL,
  LOAD_MORE_MESSAGES_START,
  LOAD_MORE_MESSAGES_SUCCESS,
  NEW_CHAT_BOT,
  PUSH_COMPANY_TOKEN_QUOTA_FAIL,
  PUSH_COMPANY_TOKEN_QUOTA_START,
  PUSH_COMPANY_TOKEN_QUOTA_SUCCESS,
  READ_MESSAGES_IN_CHAT,
  REPLACE_THINKING_MESSAGE,
  SEARCH_GROUPS,
  SEARCH_USERS_FAIL,
  SEARCH_USERS_START,
  SEARCH_USERS_SUCCESS,
  SET_REPLY_MESSAGE,
  SET_SELECTED_BOT,
  SET_SELECTED_CHAT_TOPIC,
  SET_SELECTED_USER,
  STOP_SWITCHING_LOADING,
  UPDATE_BOT_SYSTEM_PROMPT_FAIL,
  UPDATE_BOT_SYSTEM_PROMPT_START,
  UPDATE_BOT_SYSTEM_PROMPT_SUCCESS,
  UPDATE_BOT_TEMPERATURE_FAIL,
  UPDATE_BOT_TEMPERATURE_START,
  UPDATE_BOT_TEMPERATURE_SUCCESS,
  UPDATE_BOT_TOOLS_FAIL,
  UPDATE_BOT_TOOLS_START,
  UPDATE_BOT_TOOLS_SUCCESS,
  UPDATE_BREAKOUT_REPORT_FAIL,
  UPDATE_BREAKOUT_REPORT_START,
  UPDATE_BREAKOUT_REPORT_SUCCESS,
  UPDATE_CHAT_GROUP,
  UPDATE_CHAT_GROUP_AUTHOR_FAIL,
  UPDATE_CHAT_GROUP_AUTHOR_START,
  UPDATE_CHAT_GROUP_AUTHOR_SUCCESS,
  UPDATE_CHAT_GROUP_BY_ID_FAIL,
  UPDATE_CHAT_GROUP_BY_ID_START,
  UPDATE_CHAT_GROUP_BY_ID_SUCCESS,
  UPDATE_CHAT_GROUP_USERS_FAIL,
  UPDATE_CHAT_GROUP_USERS_START,
  UPDATE_CHAT_GROUP_USERS_SUCCESS,
  UPDATE_COMPANY_TOKEN_QUOTA,
  UPDATE_MINI_GROUP_FAIL,
  UPDATE_MINI_GROUP_START,
  UPDATE_MINI_GROUP_SUCCESS,
} from './constants';

import { API_URL, API_URL_V3 } from '@shared/constants/config';
import { DELETE, GET, PATCH, POST, PUT, REST_API } from '@shared/constants/rest-api';
import getQueryString from '@shared/utils/get-query-string';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

const defaultToken = '';

export const getChats = ({ isPersonal, chatId = null }, page = 1) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/list${getQueryString({ isPersonal, chatId, page, size: 20 })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_CHATS_START, GET_CHATS_SUCCESS, GET_CHATS_FAIL],
});

export const getChatBots = () => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_CHAT_BOTS_START, GET_CHAT_BOTS_SUCCESS, GET_CHAT_BOTS_FAIL],
});

export const getChatMentorGroups = requestId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/mentor/${requestId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_CHATS_START, GET_CHATS_SUCCESS, GET_CHATS_FAIL],
});

export const createChatGroup = (chatName, chatPhotoUuid, users) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/chat`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: {
    chatName,
    chatPhotoUuid,
    users,
  },
  withoutRefresh: true,
  types: [CREATE_CHAT_GROUP_START, CREATE_CHAT_GROUP_SUCCESS, CREATE_CHAT_GROUP_FAIL],
});

export const createChatTopic = (chatId, data) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/chat/${chatId}/topic`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: data,
  withoutRefresh: true,
  types: [CREATE_CHAT_TOPIC_START, CREATE_CHAT_TOPIC_SUCCESS, CREATE_CHAT_TOPIC_FAIL],
});

export const createChatGroupMentor = (requestId, mentorUserId, menteeUserId) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/chat/mentor/`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: {
    mentorUserId,
    menteeUserId,
    requestId,
  },
  withoutRefresh: true,
  types: [CREATE_CHAT_GROUP_START, CREATE_CHAT_GROUP_SUCCESS, CREATE_CHAT_GROUP_FAIL],
});

export const updateChatGroup = (chatId, data) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL_V3}/chat/${chatId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  body: data,
  types: [UPDATE_CHAT_GROUP_BY_ID_START, UPDATE_CHAT_GROUP_BY_ID_SUCCESS, UPDATE_CHAT_GROUP_BY_ID_FAIL],
});

export const deleteChatGroupById = (chatId, onSuccess) => ({
  type: REST_API,
  method: DELETE,
  url: `${API_URL_V3}/chat/${chatId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [DELETE_CHAT_GROUP_BY_ID_START, DELETE_CHAT_GROUP_BY_ID_SUCCESS, DELETE_CHAT_GROUP_BY_ID_FAIL],
  onSuccess,
});

export const deleteChatGroupByRequestId = requestId => ({
  type: REST_API,
  method: DELETE,
  url: `${API_URL_V3}/chat/mentor/${requestId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [DELETE_CHAT_GROUP_BY_ID_START, DELETE_CHAT_GROUP_BY_ID_SUCCESS, DELETE_CHAT_GROUP_BY_ID_FAIL],
});

export const searchUsers = (fullName, page, isClear = false) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/users${getQueryString({
    sort: 'lastName,asc',
    size: 20,
    fullName,
    page,
  })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [SEARCH_USERS_START, SEARCH_USERS_SUCCESS, SEARCH_USERS_FAIL],
  isClear,
});

export const getUsers = (fullName, page = 0) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/users${getQueryString({
    sort: 'lastName,asc',
    size: 20,
    fullName,
    page,
  })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_USERS_START, GET_USERS_SUCCESS, GET_USERS_FAIL],
});

export const getMessages = chatId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/messages`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_MESSAGES_START, GET_MESSAGES_SUCCESS, GET_MESSAGES_FAIL],
});

// New paginated messages actions
export const getMessagesPaginated = (chatId, page = 0, size = 20) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/messages${getQueryString({ page, size })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_MESSAGES_PAGINATED_START, GET_MESSAGES_PAGINATED_SUCCESS, GET_MESSAGES_PAGINATED_FAIL],
});

export const loadMoreMessages = (chatId, page, size = 20) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/messages${getQueryString({ page, size })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [LOAD_MORE_MESSAGES_START, LOAD_MORE_MESSAGES_SUCCESS, LOAD_MORE_MESSAGES_FAIL],
});

export const getUsersInGroup = (chatId, page) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/users${getQueryString({
    page,
    size: 20,
  })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_USERS_IN_CHAT_START, GET_USERS_IN_CHAT_SUCCESS, GET_USERS_IN_CHAT_FAIL],
});

export const getCountNewMessages = () => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/messages/new/count`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [CHECK_NEW_MESSAGE_START, CHECK_NEW_MESSAGE_SUCCESS, CHECK_NEW_MESSAGE_FAIL],
});

export const changeAuthorGroup = (chatId, authorId, onSuccess) => ({
  type: REST_API,
  method: PATCH,
  url: `${API_URL_V3}/chat/${chatId}/author/${authorId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  body: { chatId },
  types: [UPDATE_CHAT_GROUP_AUTHOR_START, UPDATE_CHAT_GROUP_AUTHOR_SUCCESS, UPDATE_CHAT_GROUP_AUTHOR_FAIL],
  onSuccess,
});

export const deleteGroupUser = (chatId, userId) => ({
  type: REST_API,
  method: DELETE,
  url: `${API_URL_V3}/chat/${chatId}/user/${userId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  body: { chatId },
  types: [DELETE_CHAT_GROUP_USER_START, DELETE_CHAT_GROUP_USER_SUCCESS, DELETE_CHAT_GROUP_USER_FAIL],
});

export const addNewUsers = (chatId, userIds) => ({
  type: REST_API,
  method: PATCH,
  url: `${API_URL_V3}/chat/${chatId}/users`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  body: { userIds },
  types: [UPDATE_CHAT_GROUP_USERS_START, UPDATE_CHAT_GROUP_USERS_SUCCESS, UPDATE_CHAT_GROUP_USERS_FAIL],
});

export const changeStatusChat = (chatId, status) => ({
  type: REST_API,
  method: PATCH,
  url: `${API_URL_V3}/chat/${chatId}/topic/change`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: { status },
  withoutRefresh: true,
  types: [CHANGE_STATUS_CHAT_START, CHANGE_STATUS_CHAT_SUCCESS, CHANGE_STATUS_CHAT_FAIL],
});

export const getChatTopics = chatId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/topic/list`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_CHAT_TOPICS_START, GET_CHAT_TOPICS_SUCCESS, GET_CHAT_TOPICS_FAIL],
});

export const checkChatInTrack = trackId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/check/in/track/${trackId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [CHECK_CHAT_IN_TRACK_START, CHECK_CHAT_IN_TRACK_SUCCESS, CHECK_CHAT_IN_TRACK_FAIL],
});

export const getMiniGroups = chatId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/group`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_MINI_GROUP_START, GET_MINI_GROUP_SUCCESS, GET_MINI_GROUP_FAIL],
});

export const createMiniGroup = (dto, chatId, onSuccess) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/chat/${chatId}/group`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: dto,
  withoutRefresh: true,
  types: [CREATE_MINI_GROUP_START, CREATE_MINI_GROUP_SUCCESS, CREATE_MINI_GROUP_FAIL],
  onSuccess,
});

export const updateMiniGroup = (dto, chatId, groupId, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL_V3}/chat/${chatId}/group/${groupId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  body: dto,
  types: [UPDATE_MINI_GROUP_START, UPDATE_MINI_GROUP_SUCCESS, UPDATE_MINI_GROUP_FAIL],
  onSuccess,
});

export const deleteMiniGroup = (chatId, groupId, onSuccess) => ({
  type: REST_API,
  method: DELETE,
  url: `${API_URL_V3}/chat/${chatId}/group/${groupId}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [DELETE_MINI_GROUP_START, DELETE_MINI_GROUP_SUCCESS, DELETE_MINI_GROUP_FAIL],
  onSuccess,
});

export const getBreakoutReports = chatId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/reports`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_BREAKOUT_REPORT_START, GET_BREAKOUT_REPORT_SUCCESS, GET_BREAKOUT_REPORT_FAIL],
});

export const createBreakoutReport = (chatId, content, onSuccess) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/chat/${chatId}/report`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: { content },
  withoutRefresh: true,
  types: [CREATE_BREAKOUT_REPORT_START, CREATE_BREAKOUT_REPORT_SUCCESS, CREATE_BREAKOUT_REPORT_FAIL],
  onSuccess,
});

export const updateBreakoutReport = (chatId, content, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL_V3}/chat/${chatId}/report`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: { content },
  withoutRefresh: true,
  types: [UPDATE_BREAKOUT_REPORT_START, UPDATE_BREAKOUT_REPORT_SUCCESS, UPDATE_BREAKOUT_REPORT_FAIL],
  onSuccess,
});

export const getCurrentUserGroupId = chatId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/chat/${chatId}/group/current-user`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_CURRENT_USER_GROUP_ID_START, GET_CURRENT_USER_GROUP_ID_SUCCESS, GET_CURRENT_USER_GROUP_ID_FAIL],
});

export const setSelectedUser = data => ({
  type: SET_SELECTED_USER,
  data,
});

export const setSelectedChatTopic = data => ({
  type: SET_SELECTED_CHAT_TOPIC,
  data,
});

export const clearSearchUsers = () => ({
  type: CLEAR_SEARCH_USERS,
});

export const addNewMessageInChat = data => ({
  type: ADD_NEW_MESSAGE_IN_CHAT,
  data,
});

export const addNewGroup = data => ({
  type: ADD_NEW_GROUP,
  data,
});

export const addNewSystemMessage = data => ({
  type: ADD_NEW_SYSTEM_MESSAGE,
  data,
});

export const clearMessages = () => ({
  type: CLEAR_MESSAGES,
});

// Новый action для полной очистки при переключении чатов
export const clearChatForSwitch = () => ({
  type: CLEAR_MESSAGES,
});

export const clearSelectedUser = () => ({
  type: CLEAR_SELECTED_USER,
});

export const clearSelectedChatTopic = () => ({
  type: CLEAR_SELECTED_CHAT_TOPIC,
});

export const readMessagesInChat = data => ({
  type: READ_MESSAGES_IN_CHAT,
  data,
});

export const addNewMessage = data => ({
  type: ADD_NEW_MESSAGE,
  data,
});

export const setReplyMessage = data => ({
  type: SET_REPLY_MESSAGE,
  data,
});

export const clearReplyMessage = () => ({
  type: CLEAR_REPLY_MESSAGE,
});

export const clearGroups = () => ({
  type: CLEAR_GROUPS,
});

export const clearUsers = () => ({
  type: CLEAR_USERS,
});

export const searchGroups = data => ({
  type: SEARCH_GROUPS,
  data,
});

export const clearFoundGroups = () => ({
  type: CLEAR_FOUND_GROUPS,
});

export const clearPersonalGroups = () => ({
  type: CLEAR_PERSONAL_GROUPS,
});

export const deleteChatGroup = data => ({
  type: DELETE_CHAT_GROUP,
  data,
});

export const updateChatGroupInfo = data => ({
  type: UPDATE_CHAT_GROUP,
  data,
});

export const addNewPersonalGroup = data => ({
  type: ADD_NEW_PERSONAL_GROUP,
  data,
});

export const addNewChatTopic = data => ({
  type: ADD_NEW_CHAT_TOPIC,
  data,
});

export const changeStatusSelectedChat = () => ({
  type: CHANGE_STATUS_CHAT,
});

export const addNewMessageInChatSlow = data => ({
  type: ADD_NEW_MESSAGE_SLOW,
  data,
});

export const addNewChatBot = data => ({
  type: NEW_CHAT_BOT,
  data,
});

// Bot settings actions
export const getBotSystemPrompt = botId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots/${botId}/system_prompt`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_BOT_SYSTEM_PROMPT_START, GET_BOT_SYSTEM_PROMPT_SUCCESS, GET_BOT_SYSTEM_PROMPT_FAIL],
});

export const updateBotSystemPrompt = (botId, systemPrompt, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL_V3}/bots/${botId}/system_prompt`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: { systemPrompt },
  withoutRefresh: true,
  types: [UPDATE_BOT_SYSTEM_PROMPT_START, UPDATE_BOT_SYSTEM_PROMPT_SUCCESS, UPDATE_BOT_SYSTEM_PROMPT_FAIL],
  onSuccess,
});

export const getBotTools = botId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots/${botId}/tools`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_BOT_TOOLS_START, GET_BOT_TOOLS_SUCCESS, GET_BOT_TOOLS_FAIL],
});

export const updateBotTools = (botId, toolsDescriptions, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL_V3}/bots/${botId}/tools`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: { toolsDescriptions },
  withoutRefresh: true,
  types: [UPDATE_BOT_TOOLS_START, UPDATE_BOT_TOOLS_SUCCESS, UPDATE_BOT_TOOLS_FAIL],
  onSuccess,
});

export const getAvailableTools = botId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots/${botId}/tools/available`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_AVAILABLE_TOOLS_START, GET_AVAILABLE_TOOLS_SUCCESS, GET_AVAILABLE_TOOLS_FAIL],
});

export const getAllAvailableTools = () => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots/tools/available`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_AVAILABLE_TOOLS_START, GET_AVAILABLE_TOOLS_SUCCESS, GET_AVAILABLE_TOOLS_FAIL],
});

// Bot temperature actions
export const getBotTemperature = botId => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots/${botId}/temperature`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_BOT_TEMPERATURE_START, GET_BOT_TEMPERATURE_SUCCESS, GET_BOT_TEMPERATURE_FAIL],
});

export const updateBotTemperature = (botId, temperature, onSuccess) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL_V3}/bots/${botId}/temperature`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: { temperature },
  withoutRefresh: true,
  types: [UPDATE_BOT_TEMPERATURE_START, UPDATE_BOT_TEMPERATURE_SUCCESS, UPDATE_BOT_TEMPERATURE_FAIL],
  onSuccess,
});

// Bot list actions
export const getBotsList = () => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/bots`, // Обновленный эндпоинт с информацией о моделях
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_BOTS_LIST_START, GET_BOTS_LIST_SUCCESS, GET_BOTS_LIST_FAIL],
});

// Selected bot actions
export const setSelectedBot = bot => ({
  type: SET_SELECTED_BOT,
  data: bot,
});

export const clearSelectedBot = () => ({
  type: CLEAR_SELECTED_BOT,
});

// Thinking messages actions
export const addThinkingMessage = (chatId, messageData) => ({
  type: ADD_THINKING_MESSAGE,
  data: { chatId, messageData },
});

export const replaceThinkingMessage = (chatId, oldMessageId, newMessage) => ({
  type: REPLACE_THINKING_MESSAGE,
  data: { chatId, oldMessageId, newMessage },
});

// Provider change action
export const changeProvider = (chatId, modelName) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/chats/${chatId}/messages`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
    'Content-Type': 'application/json',
  },
  data: {
    content: `/provider ${modelName}`,
  },
  withoutRefresh: true,
});

// Token usage actions
export const getCompanyTokenQuota = () => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/token-usage/company-quota`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_COMPANY_TOKEN_QUOTA_START, GET_COMPANY_TOKEN_QUOTA_SUCCESS, GET_COMPANY_TOKEN_QUOTA_FAIL],
});

export const pushCompanyTokenQuota = () => ({
  type: REST_API,
  method: POST,
  url: `${API_URL_V3}/token-usage/push-company-quota`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [PUSH_COMPANY_TOKEN_QUOTA_START, PUSH_COMPANY_TOKEN_QUOTA_SUCCESS, PUSH_COMPANY_TOKEN_QUOTA_FAIL],
});

export const getCompanyTokenUsage = (page = 1, limit = 20) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL_V3}/token-usage/company-usage-paginated${getQueryString({ page, limit })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  withoutRefresh: true,
  types: [GET_COMPANY_TOKEN_USAGE_START, GET_COMPANY_TOKEN_USAGE_SUCCESS, GET_COMPANY_TOKEN_USAGE_FAIL],
});

export const updateCompanyTokenQuota = tokenQuota => ({
  type: UPDATE_COMPANY_TOKEN_QUOTA,
  data: tokenQuota,
});

export const stopSwitchingLoading = () => ({
  type: STOP_SWITCHING_LOADING,
});
